import type { NDateLocale, NLocale } from "naive-ui"
import type { AppLocale } from "./locale"
import { dateEnUS, dateRuRU, dateUzUZ, enUS, ruRU, uzUZ } from "naive-ui"

// Naive's own strings (pagination, tables, date pickers) must follow the UI
// language, otherwise English leaks into an otherwise translated screen.
export const naiveLocales: Record<AppLocale, { locale: NLocale; dateLocale: NDateLocale }> = {
  uz: { locale: uzUZ, dateLocale: dateUzUZ },
  ru: { locale: ruRU, dateLocale: dateRuRU },
  en: { locale: enUS, dateLocale: dateEnUS },
}
